export const generateNextVersion = (currentVersion: string): string => {
    if (!currentVersion) return '1.0.1';

    const parts = currentVersion.split('.');
    const lastPartIndex = parts.length - 1;
    const lastPart = parseInt(parts[lastPartIndex]);

    if (!isNaN(lastPart)) {
        parts[lastPartIndex] = (lastPart + 1).toString();
        return parts.join('.');
    }

    return currentVersion + '.1';
};

export const generateNextVersionFromHistory = (existingVersions: any[], fallbackVersion?: string): string => {
    // Collect all unique version numbers
    const versions = new Set<string>();

    if (existingVersions && existingVersions.length > 0) {
        existingVersions.forEach(v => {
            if (v.versionNumber) versions.add(v.versionNumber.toString());
        });
    }

    if (fallbackVersion) {
        versions.add(fallbackVersion);
    }

    if (versions.size === 0) {
        return '1.0.1';
    }

    // Sort them semantically (numeric segments)
    const sortedVersions = Array.from(versions).sort((a, b) => {
        const aParts = a.split('.').map((num: string) => parseInt(num) || 0);
        const bParts = b.split('.').map((num: string) => parseInt(num) || 0);

        for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
            const aVal = aParts[i] || 0;
            const bVal = bParts[i] || 0;
            if (aVal !== bVal) return bVal - aVal; // Descending
        }
        return 0;
    });

    console.log('Highest versions detected:', sortedVersions[0]);

    const latestVersion = sortedVersions[0];
    const parts = latestVersion.split('.');

    if (parts.length > 0) {
        const lastIdx = parts.length - 1;
        const lastNum = parseInt(parts[lastIdx]);
        if (!isNaN(lastNum)) {
            parts[lastIdx] = (lastNum + 1).toString();
            return parts.join('.');
        }
    }

    return latestVersion + '.1';
};
